import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { driverSelector, fetchOnedriver, updatedriver } from "../../api/driver";
import defaultProfile from "../../assets/3d-illustration-cartoon-character-hoodie-cap.jpg";
import { keyUri, config } from "../../key";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import storage from "../firebase.config";

export default function EditDriver() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { current_driver } = useSelector(driverSelector);
  const driver_id_ = id || localStorage.getItem("Driver");
  console.log("current driver:", current_driver);
  console.log("dirver from local storage:", driver_id_);
  const [formData, setFormData] = useState({
    name: "",
    phone_number: "",
    email: "",
    Driver_licence_number: "",
    Location: "",
    //city: "",
    state: "",
    age: "",
    gender: "",
  });

  const [errors, setErrors] = useState({});

  const [availableLocations, setAvailableLocations] = useState([]);
  const [driverImage, setDriverImage] = useState(null);


useEffect(() => {
  const fetchLocations = async () => {
    try {
      const token = localStorage.getItem("authToken"); // ✅ Always get fresh token
      const response = await fetch(
        `${keyUri.BACKEND_URI}/api/get-all-locations`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setAvailableLocations(data);
    } catch (err) {
      console.error("Error fetching locations:", err);
    }
  };

  fetchLocations();
}, []);




  useEffect(() => {
    if (driver_id_) {
      dispatch(fetchOnedriver(driver_id_));
    }
  }, [dispatch, driver_id_]);

  useEffect(() => {
    if (current_driver) {
      setFormData({
        name: current_driver.name || "",
        phone_number: current_driver.phone_number || "",
        email: current_driver.email || "",
        Driver_licence_number: current_driver.Driver_licence_number || "",
        Location: current_driver.Location || "",
        //city: current_driver.city || "",
        state: current_driver.state || "",
        age: current_driver.age || "",
        gender: current_driver.gender || "",
      });
    }
  }, [current_driver]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

 const handleImageUpload = (e) => {
  const file = e.target.files[0];
  if (file) {
    const storageRef = ref(storage, `Driver-Documents/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // optionally track progress here
      },
      (error) => {
        console.error("Upload failed:", error);
      },
      async () => {
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        setDriverImage(downloadURL); // For preview using URL
        setFormData((prev) => ({ ...prev, Driver_photo_link: downloadURL })); // Save URL, NOT base64
      }
    );
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await dispatch(updatedriver(formData, driver_id_));
      alert("Driver updated successfully!");
      navigate(-1);
    } catch (err) {
      alert("Update failed!");
    }
  };

  return (
    <div className="max-w-lg mx-auto bg-white shadow-md rounded-xl p-6 mt-40 border mb-20">
      <div className="flex justify-center mb-6 relative">
  <img
    src={driverImage || current_driver?.Driver_photo_link || defaultProfile}
    alt="Driver"
    className="w-24 h-24 rounded-full border-4 border-blue-300 object-cover cursor-pointer hover:opacity-80"
    onClick={() => document.getElementById("driver-image-upload").click()}
  />

  <input
    type="file"
    id="driver-image-upload"
    name="Driver_photo_link"
    accept="image/*"
    onChange={handleImageUpload}
    className="hidden"
  />
</div>


      <h2 className="text-2xl font-bold text-center mb-6">Edit Driver</h2>

      <form onSubmit={handleSubmit} className="space-y-6">
        {[
          { name: "name", label: "Name", editable: true },
          { name: "phone_number", label: "Phone Number", editable: false },
          { name: "email", label: "Email", editable: false },
          {
            name: "Driver_licence_number",
            label: "License Number",
            editable: true,
          },
        ].map((field) => (
          <div className="relative" key={field.name}>
            <input
              type="text"
              id={field.name}
              name={field.name}
              value={formData[field.name]}
              onChange={handleChange}
              disabled={!field.editable}
              placeholder={field.label}
              className={`peer w-full px-4 py-2 border-2 rounded-lg placeholder-transparent focus:outline-none transition-colors ${
                field.editable
                  ? "border-teal-300 focus:border-teal-500"
                  : "border-gray-200 bg-gray-100 cursor-not-allowed text-gray-500"
              } ${errors[field.name] ? "border-red-500" : ""}`}
            />
            <label
              htmlFor={field.name}
              className={`absolute left-2 -top-2.5 bg-white px-1 text-sm transition-all ${
                field.editable ? "text-teal-500" : "text-gray-500"
              }`}
            >
              {field.label}
            </label>
            {errors[field.name] && (
              <p className="mt-1 text-sm text-red-500">{errors[field.name]}</p>
            )}
          </div>
        ))}

        <div className="relative">
          <input
            type="number"
            name="age"
            id="age"
            value={formData.age}
            onChange={handleChange}
            placeholder="Age"
            className="peer w-full px-4 py-2 border-2 rounded-lg placeholder-transparent focus:outline-none border-teal-300 focus:border-teal-500"
          />
          <label
            htmlFor="age"
            className="absolute left-2 -top-2.5 bg-white px-1 text-sm text-teal-500"
          >
            Age
          </label>
        </div>

        <div className="relative">
          <select
            name="gender"
            id="gender"
            value={formData.gender}
            onChange={handleChange}
            className="peer w-full px-4 py-2 border-2 rounded-lg focus:outline-none border-teal-300 focus:border-teal-500"
          >
            <option value="">Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
          <label
            htmlFor="gender"
            className="absolute left-2 -top-2.5 bg-white px-1 text-sm text-teal-500"
          >
            Gender
          </label>
        </div>
       <div className="relative">
  <select
    name="Location"
    id="Location"
    value={formData.Location}
    onChange={handleChange}
    className="peer w-full px-4 py-2 border-2 rounded-lg focus:outline-none border-teal-300 focus:border-teal-500"
  >
    <option value="">Select Location</option>
    {availableLocations.map((loc) => (
      <option key={loc._id} value={loc.name}>
        {loc.name}
      </option>
    ))}
  </select>
  <label
    htmlFor="Location"
    className="absolute left-2 -top-2.5 bg-white px-1 text-sm text-teal-500"
  >
    Location
  </label>
</div>


     <div className="relative">
  <select
    name="state"
    id="state"
    value={formData.state}
    onChange={handleChange}
    className="peer w-full px-4 py-2 border-2 rounded-lg focus:outline-none border-teal-300 focus:border-teal-500"
  >
    <option value="">Select State</option>
    {[
      "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
      "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
      "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya",
      "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim",
      "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand",
      "West Bengal", "Andaman and Nicobar Islands", "Chandigarh",
      "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Jammu and Kashmir",
      "Ladakh", "Lakshadweep", "Puducherry"
    ].map((stateName) => (
      <option key={stateName} value={stateName}>
        {stateName}
      </option>
    ))}
  </select>
  <label
    htmlFor="state"
    className="absolute left-2 -top-2.5 bg-white px-1 text-sm text-teal-500"
  >
    State
  </label>
</div>


        <button
          type="submit"
          className="w-full bg-teal-600 text-white font-semibold py-2 rounded-lg hover:bg-teal-700"
        >
          Save Changes
        </button>
      </form>
    </div>
  );
}
